import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _styled from "@emotion/styled-base";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import React, { PureComponent } from 'react';
import { foldMarketplaceProduct } from "../../../types/MarketplaceProduct";
import ConfluenceIntegration from "./ConfluenceIntegration.svg";
import JiraIntegration from "./JiraIntegration.svg";
export var IntegrationImg = _styled("img", {
  target: "e18duu7q0",
  label: "IntegrationImg"
})(process.env.NODE_ENV === "production" ? {
  name: "v2kfba",
  styles: "height:100%;width:100%;"
} : {
  name: "v2kfba",
  styles: "height:100%;width:100%;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1NpdGVTZWxlY3RvckRpYWxvZy9JbnRlZ3JhdGlvbkltYWdlL0ludGVncmF0aW9uSW1hZ2UuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBWXdDIiwiZmlsZSI6Ii4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1NpdGVTZWxlY3RvckRpYWxvZy9JbnRlZ3JhdGlvbkltYWdlL0ludGVncmF0aW9uSW1hZ2UuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgUmVhY3QsIHsgUHVyZUNvbXBvbmVudCB9IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IHsgZm9sZE1hcmtldHBsYWNlUHJvZHVjdCB9IGZyb20gJy4uLy4uLy4uL3R5cGVzL01hcmtldHBsYWNlUHJvZHVjdCc7XG5cbmltcG9ydCB0eXBlIHsgTWFya2V0cGxhY2VQcm9kdWN0IH0gZnJvbSAnLi4vLi4vLi4vdHlwZXMvTWFya2V0cGxhY2VQcm9kdWN0JztcblxuaW1wb3J0IENvbmZsdWVuY2VJbnRlZ3JhdGlvbiBmcm9tICcuL0NvbmZsdWVuY2VJbnRlZ3JhdGlvbi5zdmcnO1xuaW1wb3J0IEppcmFJbnRlZ3JhdGlvbiBmcm9tICcuL0ppcmFJbnRlZ3JhdGlvbi5zdmcnO1xuXG5leHBvcnQgY29uc3QgSW50ZWdyYXRpb25JbWcgPSBzdHlsZWQuaW1nYFxuICBoZWlnaHQ6IDEwMCU7XG4gIHdpZHRoOiAxMDAlO1xuYDtcblxudHlwZSBQcm9wcyA9IHtcbiAgcHJvZHVjdDogTWFya2V0cGxhY2VQcm9kdWN0LFxufTtcblxuZXhwb3J0IGRlZmF1bHQgY2xhc3MgSW50ZWdyYXRpb25JbWFnZSBleHRlbmRzIFB1cmVDb21wb25lbnQ8UHJvcHM+IHtcbiAgcmVuZGVyID0gKCkgPT4gKFxuICAgIDxJbnRlZ3JhdGlvbkltZ1xuICAgICAgc3JjPXtmb2xkTWFya2V0cGxhY2VQcm9kdWN0KHRoaXMucHJvcHMucHJvZHVjdCkoXG4gICAgICAgICgpID0+IEppcmFJbnRlZ3JhdGlvbixcbiAgICAgICAgKCkgPT4gQ29uZmx1ZW5jZUludGVncmF0aW9uXG4gICAgICApfVxuICAgIC8+XG4gICk7XG59XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var IntegrationImage = /*#__PURE__*/function (_PureComponent) {
  _inherits(IntegrationImage, _PureComponent);

  var _super = _createSuper(IntegrationImage);

  function IntegrationImage() {
    var _this;

    _classCallCheck(this, IntegrationImage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      return /*#__PURE__*/React.createElement(IntegrationImg, {
        src: foldMarketplaceProduct(_this.props.product)(function () {
          return JiraIntegration;
        }, function () {
          return ConfluenceIntegration;
        })
      });
    });

    return _this;
  }

  return IntegrationImage;
}(PureComponent);

export { IntegrationImage as default };